// Testnet Cronos for local test
// export const ContractAddress = '0xe2cAB6655F33192F174781206c123C5B605480f4'

// export const defaultChainInfo = {
//   chainId: 338,
//   chainName: 'Cronos Testnet',
//   rpcUrls: ['https://evm-t3.cronos.org'],
//   iconUrls: ['https://cronoscan.com/images/brandassets/logo.jpg?v=22.12.2.0'],
//   blockExplorerUrls: ['https://cronos.crypto.org/explorer/testnet3/'],
//   nativeCurrency: {
//    name: 'Cronos',
//    symbol: 'TCRO',
//    decimals: 18,
//   }
// }

// Mainnet Cronos for live page
export const ContractAddress = "0xe2cAB6655F33192F174781206c123C5B605480f4";
export const RoyaltyContractAddress =
  "0xd2aD4b7194b0D7f3c6be397888565E7BA3BE0241";
  export const RoyaltyContractAddressOld =
  "0xd2aD4b7194b0D7f3c6be397888565E7BA3BE0241";

export const defaultChainInfo = {
  chainId: "0x19",
  chainName: "Cronos Mainnet Beta",
  rpcUrls: ["https://evm.cronos.org/"],
  iconUrls: ["https://cronoscan.com/images/brandassets/logo.jpg?v=22.12.2.0"],
  blockExplorerUrls: ["https://cronoscan.com/"],
  nativeCurrency: {
    name: "Cronos",
    symbol: "CRO",
    decimals: 18,
  },
};
